/*
 ********************************
 *	1. 특정 클래스가 있을 경우
 *	toggleFn.initFn({ 'target' : '클래스명' });
 *	or
 *	window.toggleFn.initFn({ 'target' : '클래스명' });
 *
 *	2. 특정 클래스가 없을 경우
 *	toggleFn.initFn();
 *	or
 *	window.toggleFn.initFn();
 *
 *	3. 클릭 이벤트
 *	toggleFn.clickFn(this);
 *	or
 *	window.toggleFn.clickFn(this);
 
 ********************************
 * date     :   2022.08.22.
 * writer   :   Jay.J
 ********************************

 */

document.addEventListener('DOMContentLoaded' , () =>{
    const toggleFn = (function(){
        const defaultOption = {
            target : '.js_toggle',
            $target : document.querySelectorAll('.js_toggle')
        }

        let option = {};

        const initFn = (newOption) => {
            option = Object.assign(defaultOption, newOption);
            option.$target = document.querySelectorAll(option.target);

			option.$target.forEach(el => {
				if(!(el.classList.contains('hasEvent'))){
					el.classList.add('hasEvent');
					_eventBindFn(el);
				}
			});
        }
		
		const clickFn = (el) => {
			// console.log(el);
			_mainBtnFn(el);
			_optionBtnFn(el, el.parentNode.querySelectorAll('.js_toggle_option'));
		}

		const _mainBtnFn = (target) => {
			// console.log(target);
			
			let toggleBtnArray = Array.from(document.querySelectorAll('.js_toggle_btn'));

			if(target.classList.contains('active')){
				target.classList.remove('active');

				//상품상세 옵션 토글
				if(document.querySelector('.product-view-page')){
					document.querySelector('.buy-process__option-box').classList.remove('ovf-visible');
				}
			}else{
				toggleBtnArray.forEach(function(el){
					el.classList.remove('active');
				});
				target.classList.add('active');

				//상품상세 옵션 토글
				if(document.querySelector('.product-view-page')){
					document.querySelector('.buy-process__option-box').classList.add('ovf-visible');
				}
			}
			// target.classList.toggle('active');
		}

		const _optionBtnFn = (mainBtn, optionBtn) => {
            optionBtn.forEach(ele => {
                let optionBtnArray = Array.from(ele.parentNode.parentNode.querySelectorAll('.js_toggle_option'));
                
				if(!(ele.classList.contains('hasEvent'))){
					ele.classList.add('hasEvent');
					ele.addEventListener('click', () => {
						mainBtn.classList.remove('active');
						mainBtn.innerHTML = ele.innerHTML;
						
						//상품상세 옵션 토글
						if(document.querySelector('.product-view-page')){
							document.querySelector('.buy-process__option-box').classList.remove('ovf-visible');
							
							console.log("23123123옵션선택");
						}
	
						if(ele.classList.contains('on')){
							ele.classList.remove('on');
						}else{
							optionBtnArray.forEach( (elem) => {
								elem.classList.remove('on');
							});
							ele.classList.add('on');
						}
					});
				}
            });
		}

        const _eventBindFn = (el) => {
			const mainBtn = el.querySelector('.js_toggle_btn');

            mainBtn.addEventListener('click', (event) => {
                _mainBtnFn(event.currentTarget);
				_optionBtnFn(event.currentTarget, event.target.parentNode.querySelectorAll('.js_toggle_option'));
            });
        }
    
        return {
            initFn : initFn,
			clickFn : clickFn
        }
    })();

    window.toggleFn = toggleFn;
    window.toggleFn.initFn();
});